import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  padding-top: 90px;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.pageBackground};

  ${mediaMaxWidth.phone} {
    padding-top: 70px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 600px;
  min-height: 600px;
  margin-bottom: 100px;
  align-items: center;
  position: relative;

  ${mediaMaxWidth.phone} {
    width: calc(100vw - 20px);
  }
`;

export const StepCounter = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 1;
  font-size: 0.9em;
  font-family: sans-serif;
  color: ${({ theme }) => theme.colors.primaryTextColor};
  font-weight: 300;
`;

interface IStepWrapperProps {
  description?: boolean;
  formStep?: boolean;
  thankYou?: boolean;
}

export const StepWrapper = styled.div`
  display: flex;
  width: 600px;
  flex-direction: column;
  align-items: center;
  min-height: 600px;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;

  form {
    display: flex;
    flex-direction: column;
  }

  ${mediaMaxWidth.tablet} {
    width: ${(props: IStepWrapperProps) => props.description && "480px"};
    width: ${(props: IStepWrapperProps) => props.thankYou && "480px"};
  }

  ${mediaMaxWidth.phone} {
    width: calc(100vw - 20px);
    min-height: unset;
  }
`;

export const Title = styled.h2`
  display: flex;
  justify-content: center;
  color: ${({ theme }) => theme.colors.secondary};
  margin: 40px 0 15px 0;
  font-size: 1.6em;
  text-align: center;

  ${mediaMaxWidth.phone} {
    font-size: 1.2em;
    margin: 30px 0 20px 0;
  }
`;

interface IEditCategoryButtonProps {
  disabled?: boolean;
}

export const EditCategoryButton = styled.button`
  border: none;
  background-color: ${(props: IEditCategoryButtonProps) =>
    props.disabled ? "#a0a0a0" : "#79D9D9"};
  pointer-events: ${(props: IEditCategoryButtonProps) =>
    props.disabled && "none"};
  color: ${({ theme }) => theme.colors.white};
  padding: 4px 35px 3px 10px;
  font-size: 1.05em;
  border-radius: 20px;
  cursor: pointer;
  position: relative;

  svg {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 0.8em;
  }

  &:focus {
    outline: none;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.secondary};
  }

  ${mediaMaxWidth.phone} {
    padding: 4px 25px 4px 10px;
    font-size: 0.9em;

    svg {
      position: absolute;
      font-size: 0.7em;
    }
  }
`;

interface IRadioButtonGroupWrapperProps {
  marginTop?: number;
}

export const RadioButtonGroupWrapper = styled.div`
  display: flex;
  margin: ${(props: IRadioButtonGroupWrapperProps) =>
    props.marginTop ? `${props.marginTop}px 0 60px 0` : "50px 0 60px 0"};
  width: 100%;
  justify-content: space-around;

  ${mediaMaxWidth.phone} {
    margin: 20px 0;
    justify-content: space-between;
  }
`;

interface IRadioButtonGroupProps {
  width: number;
}

export const RadioButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: ${(props: IRadioButtonGroupProps) => `${props.width}px`};

  .input-wrapper {
    margin-bottom: 15px;
  }

  input[type="text"] {
    width: 220px;
  }

  .error-message {
    width: 220px;
  }

  ${mediaMaxWidth.phone} {
    margin: 0 auto;
    width: ${(props: IRadioButtonGroupProps) => `${props.width * 0.9}px`};

    input[type="text"] {
      width: 170px;
    }
  }
`;

interface IParagraphProps {
  first?: boolean;
  last?: boolean;
  centered?: boolean;
}

export const Paragraph = styled.p`
  color: ${({ theme }) => theme.colors.secondary};
  margin: 15px 0;
  margin: ${(props: IParagraphProps) => props.first && "25px 0 15px 0"};
  margin: ${(props: IParagraphProps) => props.last && "15px 0 50px 0"};
  line-height: 1.45em;
  font-size: 1.1em;
  text-align: ${(props: IParagraphProps) => props.centered && "center"};

  ${mediaMaxWidth.phone} {
    font-size: 1em;
    margin: ${(props: IParagraphProps) => props.last && "15px 0 20px 0"};
  }
`;

export const Spinner = styled.img``;

interface IReCaptchaContainerProps {
  disabled: boolean;
}

export const ReCaptchaContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 60px;
  align-items: center;
  position: relative;
  top: -40px;
  transition: 0.1s ease-in-out;
  filter: ${(props: IReCaptchaContainerProps) =>
    props.disabled ? "opacity(0.4) grayscale(1)" : "none"};
  pointer-events: ${(props: IReCaptchaContainerProps) =>
    props.disabled && "none"};

  ${mediaMaxWidth.phone} {
    margin-bottom: 20px;
    top: 0px;
  }
`;

export const ReCaptchaError = styled.div`
  text-align: center;
  position: absolute;
  bottom: -15px;
  font-size: 0.82em;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 600;
`;

export const ButtonsWrapper = styled.div`
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0;

  ${mediaMaxWidth.phone} {
    position: relative;
    margin-top: 20px;
  }
`;

export const DisabledButton = styled.button`
  position: relative;
  margin: 0 auto;
  justify-content: center;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.white};
  background-color: #ababab;
  border: 1px solid #fff;
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.borderRadiusSmall};
  line-height: 22px;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  padding: 10px 12px;
  font-family: ${({ theme }) => theme.borderRadiusSmall};
  letter-spacing: 0.03em;
  text-transform: capitalize;
  font-size: 1em;
  min-width: 100px;
  min-height: 44px;
  cursor: not-allowed;
  transition: 0.1s ease-in-out;
  outline: 2px solid transparent;

  ${mediaMaxWidth.phone} {
    margin: 0 0 0 auto;
  }
`;

interface IBackButtonProps {
  disabled?: boolean;
}

export const BackButton = styled.button`
  position: absolute;
  left: 0;
  background: none;
  color: ${(props: IBackButtonProps) =>
    props.disabled ? "#a0a0a0" : "#79D9D9"};
  pointer-events: ${(props: IBackButtonProps) => props.disabled && "none"};
  border: none;
  font-size: 1.2em;
  cursor: pointer;
  display: flex;
  align-items: center;

  svg {
    margin-right: 5px;
    font-size: 0.8em;
  }

  &:hover {
    color: #402680;
  }

  ${mediaMaxWidth.phone} {
    padding: 0;
  }
`;

interface IButtonProps {
  formLoading?: boolean;
}

export const Button = styled.button`
  margin: 0 auto;
  justify-content: center;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${(props: IButtonProps) =>
    props.formLoading ? "ababab" : "#79D9D9"};
  border: ${(props: IButtonProps) =>
    props.formLoading ? "1px solid #ffffff" : "1px solid #79D9D9"};
  cursor: ${(props: IButtonProps) => props.formLoading && "not-allowed"};
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.borderRadiusSmall};
  line-height: 22px;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  padding: 10px 12px;
  font-family: ${({ theme }) => theme.fontFamily};
  letter-spacing: 0.03em;
  text-transform: capitalize;
  font-size: 1em;
  min-width: 100px;
  max-width: 100;
  height: 44px;
  transition: 0.1s ease-in-out;
  outline: 2px solid transparent;
  overflow: hidden;
  pointer-events: ${(props: IButtonProps) => props.formLoading && "none"};
  position: relative;

  &:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.white};
    background-color: ${(props: IButtonProps) =>
      !props.formLoading && "#79D9D9"};
    border: ${(props: IButtonProps) =>
      !props.formLoading && "1px solid #79D9D9"};
    pointer-events: ${(props: IButtonProps) => props.formLoading && "none"};
  }

  &:focus {
    outline: ${(props: IButtonProps) =>
      props.formLoading ? "2px solid #8064d4" : "none"};
    background-color: ${(props: IButtonProps) =>
      props.formLoading ? "ababab" : "#79D9D9"};
    border: ${(props: IButtonProps) =>
      props.formLoading ? "1px solid #ffffff" : "1px solid #402680"};
  }

  ${Spinner} {
    width: 26px;
    position: absolute;
    top: 8px;
    left: 0;
    right: 0;
    margin: 0 auto;
  }

  ${mediaMaxWidth.phone} {
    margin: 0 0 0 auto;
  }
`;
